import * as z from "zod";

/**
 * Control signals for a turn running off the request, carried in the stream's
 * `status` event so clients that predate them drop them.
 */
const ASK_REDO_TURN_STATUS_PREFIX = "ask-redo-turn:";

const AskRedoTurnStatusSchema_ = z.discriminatedUnion("kind", [
  /** `cursor`: index of the next buffered turn event this stream sends; every later non-`turn` event advances it by one. */
  z.object({
    kind: z.literal("turn"),
    threadId: z.string(),
    turnId: z.string(),
    cursor: z.number().int().min(0),
  }),
  /** The turn restarted after a worker failure: reload the thread and watch again. */
  z.object({ kind: z.literal("restarted") }),
]);
export const AskRedoTurnStatusSchema: z.ZodType<AskRedoTurnStatus> =
  AskRedoTurnStatusSchema_;
export type AskRedoTurnStatus = z.infer<typeof AskRedoTurnStatusSchema_>;

export function encodeAskRedoTurnStatus(status: AskRedoTurnStatus): string {
  return `${ASK_REDO_TURN_STATUS_PREFIX}${JSON.stringify(status)}`;
}

/** Undefined for any other status string. */
export function parseAskRedoTurnStatus(
  status: string,
): AskRedoTurnStatus | undefined {
  if (!status.startsWith(ASK_REDO_TURN_STATUS_PREFIX)) {
    return undefined;
  }
  let json: unknown;
  try {
    json = JSON.parse(status.slice(ASK_REDO_TURN_STATUS_PREFIX.length));
  } catch {
    return undefined;
  }
  const parsed = AskRedoTurnStatusSchema_.safeParse(json);
  return parsed.success ? parsed.data : undefined;
}
